@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.plan-grid-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: @space-24;
  margin-bottom: @space-24;

  @media @desktop {
    gap: @space-16;
  }

  @media @tablet, @mobile {
    gap: @space-4;
  }
}

.plan-section {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.plan-attribute {
  height: 32px;
  text-align: center;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.selected {
    color: var(--white);
    background-color: var(--blue-900);
    border: 2px solid var(--blue-900);
  }
}

.highlighted {
  background-color: var(--grey-200);
  border-top: 1px solid var(--default--border-color--12);
  border-left: 1px solid var(--default--border-color--12);
  border-right: 1px solid var(--default--border-color--12);
}

.plan-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  cursor: pointer;
  padding: @space-16;
  background-color: var(--light--background-color--1);
  border: 1px solid var(--default--border-color--12);
  border-radius: 4px;
}

.plan-header {
  font-weight: @bold;
  text-align: center;
  margin-bottom: @space-24;
}

.price-value {
  font-weight: 500;
}

.plan-info-section {
  margin-bottom: @space-24;
}

.shipment-limit-dropdown-item {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.centered-shipment-limit {
  align-content: center;
  height: 56px;
  text-align: center;
}

.feature-label {
  font-weight: @semi-bold;
}

.feature-list {
  display: block;
  margin-left: @space-16;

  > li {
    display: block;
  }
}

.feature-line-item {
  display: list-item;
  list-style: disc;
}

.selected {
  border: 2px solid var(--blue-900);
  box-shadow: 0 4px 2px 0 var(--default--box-shadow-color--3);
}

.selected-highlighted {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.shipment-limit-dropdown {
  width: 100%;
}

.shipment-dropdown-toggler {
  height: 32px;
}
